import { render, staticRenderFns } from "./header-nav.vue?vue&type=template&id=1b83ff7c&scoped=true&"
import script from "./header-nav.vue?vue&type=script&lang=ts&"
export * from "./header-nav.vue?vue&type=script&lang=ts&"
import style0 from "./header-nav.vue?vue&type=style&index=0&id=1b83ff7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b83ff7c",
  null
  
)

export default component.exports